"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyDatePicker = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const StyledTextField = (0, material_1.styled)(material_1.TextField)({
  [`&.${material_1.textFieldClasses.root}`]: {
    minWidth: 210
  },
  [`& .${material_1.inputClasses.root}`]: {
    fontSize: 16
  },
  [`& .${material_1.inputLabelClasses.root}`]: {
    fontSize: 16
  }
});

const SskyDatePicker = props => {
  let inputProps = {};

  if (props.min) {
    Object.assign(inputProps, {
      min: props.min
    });
  }

  if (props.max) {
    Object.assign(inputProps, {
      max: props.max
    });
  }

  const InputProps = {
    inputProps
  };
  const InputLabelProps = {
    shrink: true
  };
  return react_1.default.createElement(StyledTextField, {
    id: props.id,
    className: props.className,
    error: props.error,
    helperText: props.helperText,
    label: props.label || "",
    type: "date",
    value: props.value,
    defaultValue: props.defaultValue,
    fullWidth: props.fullWidth,
    onChange: props.onChange,
    InputProps: InputProps,
    InputLabelProps: InputLabelProps,
    disabled: props.disabled,
    "data-testid": props.dataTestId || `testId-${props.id}`,
    variant: "standard"
  });
};

exports.SskyDatePicker = SskyDatePicker;
exports.default = react_1.default.memo(SskyDatePicker);